export const usersKeys = {
  all: ['users'] as const,
  list: (...args: unknown[]) => [...usersKeys.all, 'list', ...args] as const,
};
